/* tslint:disable */
/* eslint-disable */

/**
 * The types of professions.
 */
export enum ProfessionType {
  Physician = 'Physician',
  Other = 'Other'
}
